import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../api-client/MyApiClient';
import DEFAULT_USER from "../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../components/Util/oders';

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Non pagato', 'Pagato'];

export const ReferralTable = () => {

	const navigate = useNavigate();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [
		{
			Header: 'Struttura',
			Footer: 'Struttura',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px'
					}}
				  />
				  {row.original.name}
				</div>
			)
		},
		{
			Header: 'Numero DonAction',
			Footer: 'Numero DonAction',
			accessor: 'numberOfReferral',
			disableGlobalFilter: true,
		},
		{
			Header: 'Da data',
			Footer: 'Da data',
			accessor: 'startDate',
  			Cell: ({ value }) => new Date(value).toLocaleDateString('it-IT'),
			disableGlobalFilter: true,
			sortType: dateTimeSort
		},
		{
			Header: 'A data',
			Footer: 'A data',
			accessor: 'endDate',
  			Cell: ({ value }) => new Date(value).toLocaleDateString('it-IT'),
			disableGlobalFilter: true,
			sortType: dateTimeSort
		},
		{
			Header: 'Importo',
			Footer: 'Importo',
			accessor: 'numberOfReferralEarn',
			disableGlobalFilter: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status',
			Cell: ({ row }) => {
				return (row && 
				  <div className="d-flex align-items-center">
					<i className={`fa fa-circle me-1 ${row.original.status?.class}`}></i>
					<div>
					  {row.original.status?.label}
					  {row.original.payedTime && (
						<small className="text-muted d-block">
							Pagato il {new Date(row.original.payedTime).toLocaleDateString('it-IT')}
						</small>
					  )}
					</div>
				  </div>
				);
			},
			disableGlobalFilter: true,
		},
	];

	const [data_json, setDataJson] = useState(null);
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status?.label)),
		[data_json, statoFilter],
	);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [customersData] = await Promise.all([
                        apiClient.getAdminReferral(token)
                    ]);
					setLoadingShowed(false);

					let data_customers = [];
					if(customersData) {
						customersData.forEach(element => {
							
							let image = null;
							if(element.picture && element.picture.uri) {
								image = element.picture.uri;
							}

							let status = null;
							if(element.status==='NOT_PAYED') {
								status = {
									"label": "Non pagato",
									"class": "text-danger"
								};
							} else if(element.status==='PAYED') {
								status = {
									"label": "Pagato",
									"class": "text-success"
								};
							}
							
							let customers_row = {
								"id": element.userId,
								"name": element.name,
								"numberOfReferral": element.numberOfReferral,
								"numberOfReferralEarn": "€ "+(element.numberOfReferral * 10).toFixed(2),
								"imageUrl": image,
								"startDate": element.startDate,
								"endDate": element.endDate,
								"status": status || { "label": ({ SUSPENDED: "Sospeso", INVITED: "Invitato" })[element.profileStatus || element.status] || element.profileStatus || element.status || "—", "class": "" }, // stato non previsto: si mostra invece di bloccare la lista
								"originalStatus": element.status,
								"transactionEmail": element.transactionEmail,
								"payedTime": element.payedTime ?? null
							};

                            if(element.numberOfReferral>0) {
                                data_customers.push(customers_row);
                            }
						});
					}
					setDataJson(data_customers);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	// La riga apre la scheda del periodo: «Profilo struttura», «Utenti DonAction» e «Imposta come pagato» stanno lì (03/10/2026)
	function apriPeriodo(row) {
		navigate('/superadmin/referral/pagamento/' + row.id + '/' + encodeURIComponent(row.startDate), { state: { periodo: row } });
	}

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				cardTitle={'DonAction strutture sportive'}
				pageList={true}
				hasSearch={true}
				searchPlaceholder={'Cerca per struttura'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				hasAddMore={false}
				data_column={data_column}
				openColumn={'name'}
				openRow={(row) => apriPeriodo(row)}
				data_json={filteredData}
				sort_by={'startDate'}
                sort_type={'desc'}
			/>
		</>
	)

}
export default ReferralTable;